import { BETA_HOSTS } from './constants';

/**
 * Flags:
  'mb-debugger',
  'mb-right-sidebar-visible',
  'mb-right-sidebar-content',
  'mb-user-returning-times',
 */

(() => {
  // User returning times flag
  try {
    const userReturningTimes = localStorage.getItem('mb-user-returning-times');

    if (!userReturningTimes) {
      localStorage.setItem('mb-user-returning-times', '1');
    } else {
      const update = `${parseInt(userReturningTimes, 10) + 1}`;
      localStorage.setItem('mb-user-returning-times', update);
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Couldn\'t set user returning times flag', e);
  }
})();

export const getFlag = (name) => {
  try {
    return localStorage.getItem(name);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Couldn't get debugger flag ${name}`, e);
    return null;
  }
};

export const isBetaDomain = () => {
  try {
    const { location: { host } } = window;

    return BETA_HOSTS.includes(host);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error("Couldn't get window location host", e.message);
    return '';
  }
};

export const updateFlags = (name, value) => {
  try {
    localStorage.setItem(name, value);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(`Couldn't set debugger flag ${name}`, e);
  }
};
